import React, { useEffect } from "react";
import styles from "./index.module.less";
import { Col, Row } from "antd";
import { g4 } from "../../../../utils/helper";
import Refresh from "@Components/common/Refresh";

const SubscriptionPreside = ({
  category_info,
  config = {
    icon: "",
    color: "",
  },
}) => {
  useEffect(() => {}, []);

  return (
    <Refresh
      refresh={() => {
        g4("video_exposured", {
          page: "影音詳情頁",
          spm: "",
          channel: "影音",
          module: "欄目展示區",
          element: "欄目",
          element_id: category_info?.title,
          object_type: "",
          object_id: "",
          sub_module: "",
          next_spm: "7.263.77.98",
        });
      }}
    >
      <a
        href={decodeURIComponent(encodeURIComponent(`https://c.8891.com.tw/movie/category/${category_info?.title}`))}
        target='_blank'
        className={styles["SubscriptionPreside"]}
        onClick={() => {
          g4("video_clicked", {
            page: "影音詳情頁",
            spm: "",
            channel: "影音",
            module: "欄目展示區",
            element: "欄目",
            element_id: category_info?.title,
            object_type: "",
            object_id: "",
            sub_module: "",
            next_spm: "7.263.77.98",
          });
        }}
      >
        <div className={styles["row-top"]}>
          <img src={category_info?.icon} />
        </div>
        <Row className={styles["row-bottom"]} align='middle' type='flex'>
          {Array.isArray(category_info?.presenter) && (
            <Col
              className={styles["bottom-text"]}
              style={{ color: config.color ? config.color : "#fff", opacity: "0.5" }}
            >
              {category_info?.presenter.map((item, index) => (
                <React.Fragment key={item.kolId}>
                  <span>{item.name}</span>
                  {category_info?.presenter.length !== index + 1 && <span>、</span>}
                </React.Fragment>
              ))}
            </Col>
          )}
          <Col className={styles["bottom-btn"]} style={{ color: config.color ? config.color : "#fff" }}>
            共 {category_info?.total} 支
            <img src={config.icon ? config.icon : "https://photo.8891.com.tw/2022/10/10/1665368082902001.png"} />
          </Col>
        </Row>
      </a>
    </Refresh>
  );
};

export default SubscriptionPreside;
